import type { HistoryItem, Role } from "./types";

const SESSION_KEY = "webclipboard.session.v1";
const HISTORY_KEY = "webclipboard.history.v1";

export interface PersistedSession {
  role: Role;
  code: string;
  cid: string;
  hasConnected: boolean;
}

export function saveSession(s: PersistedSession): void {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(s));
  } catch {}
}

export function loadSession(): PersistedSession | undefined {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return undefined;
    const obj = JSON.parse(raw) as Partial<PersistedSession>;
    if (obj.role !== "host" && obj.role !== "guest") return undefined;
    if (typeof obj.code !== "string" || !/^[0-9]{9}$/.test(obj.code)) return undefined;
    if (typeof obj.cid !== "string" || obj.cid.length === 0) return undefined;
    return {
      role: obj.role,
      code: obj.code,
      cid: obj.cid,
      hasConnected: !!obj.hasConnected,
    };
  } catch {
    return undefined;
  }
}

export function clearSession(): void {
  try { sessionStorage.removeItem(SESSION_KEY); } catch {}
}

export function saveHistory(items: HistoryItem[]): void {
  try {
    const cleaned: HistoryItem[] = items.map((it) => {
      if (it.kind === "file") {
        return {
          kind: "file",
          id: it.id,
          direction: it.direction,
          name: it.name,
          size: it.size,
          mime: it.mime,
          bytes: it.bytes,
          at: it.at,
        };
      }
      return it;
    });
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(cleaned));
  } catch {}
}

export function loadHistory(): HistoryItem[] {
  try {
    const raw = sessionStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const items = JSON.parse(raw);
    if (!Array.isArray(items)) return [];
    return items as HistoryItem[];
  } catch {
    return [];
  }
}

export function clearHistory(): void {
  try { sessionStorage.removeItem(HISTORY_KEY); } catch {}
}
